import { gqlFlamegraphExchange } from "@/gql-flamegraph/devtool";

export const devtoolsExchanges = [gqlFlamegraphExchange];
